<template>
  <div class="function-upload-container clipboard-body">
    <h3 class="title">
      <span>文件上传</span>
      <i v-if="!isShowConfig" title="设置" class="icon setting-icon el-icon-setting" @click="changeShowConfig"></i>
      <i v-if="!fullBoxScreen" title="全屏" class="icon fullscreen-icon el-icon-full-screen" @click="changeFullScreen"></i>
      <i v-else title="还原" class="icon fullscreen-icon  el-icon-c-scale-to-original" @click="changeFullScreen"></i>
    </h3>
    <div class="upload-card-container">
      <div class="file-upload-container">
        <!-- 上传文件夹 Folder-->
        <uploadFolder v-if="isUploadDirectory" @handleSuccess="folderUploadSuccess" @handleError="folderUploadError" :data="form" :isCompressed="isCompressed"></uploadFolder>

        <!-- 上传文件 Files-->
        <el-upload v-else ref="xps-upload" class="xps-upload" name="file_data" drag :multiple="true" action="/api/uploadCos" :on-change="handleChange" :show-file-list="false" :data="form" :on-progress="handleProgress">
          <i class="el-icon-upload upload-icon"></i>
          <p class="el-upload__text">将文件拖到此处，或<em>点击上传</em></p>
          <p class="el-upload__tip">当前支持上传所有文件类型，上传文件存储时间：{{(form.day||showSaveDay)?`${form.day||showSaveDay}天`:'永久存储'}}</p>
        </el-upload>

        <!-- 上传列表 FileList -->
        <div class="file-list-container">
          <p class="file-list-title" v-if="fileList.length">
            当前已上传文件
          </p>
          <el-row v-if="fileList.length" :gutter="20" style="margin-top: 10px">
            <el-col class="gutter-row" :span="5" style="margin-bottom: 10px" v-for="(item,index) in fileList" :key="index">
              <el-card :body-style="{ padding: '10px' }" shadow="hover" :title="item.data" class="histroy-list file-upload-card">
                <div class="cover-box">
                  <el-progress v-if="item.percent < 100" :color="customColors" type="circle" :width="circleWidth" style="line-height:200px;" :percentage="item.percent" />
                  <img class="file-icon" v-if="item.isImg && item.percent === 100" :src="item.data" />
                  <div v-else-if="item.percent === 100" class="file-icon" :class="`file-icon-${item.ext}`"></div>
                  <p class="confont-style ellipsis-name">{{item.name}}</p>
                </div>
                <el-button :style="{width: '100%'}" type="primary" v-clipboard:copy="item.data" v-clipboard:success="onCopy" :loading="item.percent === 100 ? false : true" icon="copy">复制</el-button>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="upload-form" v-show="isShowConfig">
        <i class="close-icon el-icon-circle-close" @click="changeShowConfig"></i>
        <!-- 条件表单 Form -->
        <el-form>
          <el-form-item style="margin-right:25px;" label="上传文件夹">
            <el-switch v-model="isUploadDirectory">
            </el-switch>
          </el-form-item>
          <el-form-item v-show="isUploadDirectory" style="margin-right:25px;" label="压缩文件夹">
            <el-switch v-model="isCompressed">
            </el-switch>
          </el-form-item>
          <el-form-item label="环境">
            <el-select @change="envChangeHandle" v-model="form.env" placeholder="请选择环境">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in envList" :key="item.env" :label="item.label" :value="item.env">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目">
            <el-select :clearable="true" v-model="form.path" placeholder="请选择项目" @change="pathChangeHandle" filterable>
              <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.path">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="存储时间" v-if="!form.path">
            <el-select v-model="form.day" placeholder="请选择存储时间">
              <el-option v-for="item in dayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </div>
</template>

<script>
import moment from 'moment';
import { getExt, isImg } from '@/common/utils/ext.js';
import { getNumberName } from '@/common/utils/getHashName.js';
import { xpsApi, userApi, fileManageApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import uploadFolder from '@/views/fileUpload/components/uploadFolder.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    uploadFolder,
  },
  data () {
    return {
      fileList: [],
      history: [],
      userId: '',
      userInfo: [{
        userId: '',
        fullName: ''
      }],
      date: moment(new Date()).format('YYYY-MM-DD'),
      count: 0,
      isLoad: false,
      historyFileList: [],
      customColors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: 'skyblue', percentage: 100 }
      ],
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      visible: false,
      showUnfoldIcon: false,
      size: '50%',
      timer: '',
      loading: false,
      circleWidth: 200,
      options: [],
      form: {
        path: '',
        env: '',
        day: 360
      },
      dayList: [
        {
          label: '360天',
          value: 360
        },
        {
          label: '720天',
          value: 720
        },
        {
          label: '1080天',
          value: 1080
        }
      ],
      specialPath: ['/custom/day360/', '/custom/day720/', '/custom/day1080/'],
      showSaveDay: '',
      envList: [],
      projectList: [],
      isShowConfig: false,
      isUploadDirectory: false,
      container: '',
      isCompressed: false,
    }
  },
  computed: {
    ...mapGetters(['showDateTips', 'fullBoxScreen'])
  },
  mounted () {
    // 初始化用户列表
    this.initUserList();
    // 获取环境列表
    this.getEnvList();
    // 获取文件列表容器dom对象
    this.container = document.querySelector('.file-upload-container');
    if (this.container) {
      this.circleWidth = this.container.offsetWidth / 8;
      window.addEventListener('resize', this.onWindowResize);
    }
    //绑定粘贴事件 Ctrl+V
    this.bindPaste();
    // 获取显示配置状态
    this.isShowConfig = localStorage.getItem('IS_SHOW_CONFIG') === 'true' || this.isShowConfig;
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize);
  },
  watch: {
    userId () {
      // 清除定时器
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.count = 10
      this.getHistoryFile();
      // 开启滚动加载
      this.isLoad = true
    },

  },
  methods: {
    // 是否全屏
    changeFullScreen () {
      this.$store.commit('config/SET_FULL_BOX_SCREEN', !this.fullBoxScreen)
    },
    // 是否显示配置
    changeShowConfig () {
      this.isShowConfig = !this.isShowConfig;
      localStorage.setItem('IS_SHOW_CONFIG', this.isShowConfig);
    },
    //绑定粘贴事件
    bindPaste () {
      //定义变量存储获取的图片内容
      let file = null;
      //获取clipboardBody对象
      let clipboardBody = document.querySelector(".clipboard-body");
      //定义clipboardBody标签绑定的粘贴事件处理函数
      let fun = async (e) => {
        //获取clipboardData对象
        let data = e.clipboardData || window.clipboardData;
        let date = + moment();
        //获取文件对象
        file = data.items[0].getAsFile();
        //判断文件是否存在
        if (file && file.size) {
          const day = this.form.day ? '/custom/day' + this.form.day + '/' : '';
          const uid = getNumberName(`${this.form.path}${day}${file.name}${file.size}`) // 以路径、文件名称、文件大小作为
          // 判断粘贴板的文件是否是截屏
          if (file.name === 'image.png') {
            // 以时间戳重新命名文件
            file = new File([file], `${getNumberName(date)}.png`);
          }
          // 判断文件是否已经上传
          const currentFile = this.getCurrentFile(uid);
          // 如果已经上传 返回
          if (currentFile) {
            return this.$message.warning('当前文件已经上传了哦~');
          }
          // 更新文件进度 （伪）
          this.fileList.push({ uid, percent: 0, name: file.name, isImg: isImg(file.name), ext: getExt(file.name) });
          setTimeout(() => {
            this.handleProgress({ percent: 100 }, uid, this.fileList);
          }, 500);
          // 上传服务器
          const form = new FormData();
          // 文件对象
          form.append("file_data", file);
          form.append("path", this.form.path);
          form.append("day", this.form.day);
          let data = await xpsApi.uploadCos(form);
          if (data) {
            const nowFile = this.getCurrentFile(uid);
            nowFile.percent = 100
            nowFile.data = data;
            this.getHistoryFile()
            return this.$message.success('文件上传成功！');
          } else {
            return this.$message.error('文件上传出错啦！！');
          }
        } else {
          this.$message.warning('不支持复制空文件或文件夹哦~');
        }
      }
      //通过clipboardBody绑定粘贴事件
      clipboardBody.removeEventListener('paste', fun);
      clipboardBody.addEventListener('paste', fun);
    },
    // 文件夹上传成功
    folderUploadSuccess (data) {
      const fileList = [];
      data.forEach(item => {
        fileList.push({ uid: item.id, percent: 100, name: item.filename, isImg: isImg(item.filename), ext: getExt(item.filename), data: item.url });
      });
      this.fileList = this.fileList.concat(fileList);
      this.getHistoryFile();
      this.$message.success('文件上传成功！')
    },
    // 文件夹上传失败
    folderUploadError (err) {
      console.log('uploadRequest error', err);
      this.$message.error('上传文件夹时发生错误！');
    },
    // 选择环境改变触发
    envChangeHandle () {
      this.form.path = '';
      this.getProjectList('', this.form.env);
    },
    // 项目下拉框改变 触发事件
    pathChangeHandle (path) {
      if (!path) {
        this.$nextTick(() => {
          this.form.day = 360;
        })
      } else {
        // 判断是否为特殊路径
        if (this.specialPath.includes(path)) {
          this.showSaveDay = parseInt(path.split('day')[1]);
        } else {
          this.showSaveDay = '';
        }
      }
      this.form.day = '';
    },
    // 获取环境列表
    async getEnvList () {
      const res = await fileManageApi.getEnvList();
      if (res.code === 200) {
        this.envList = res.data
        // 获取路由参数值
        this.getRouteValue();
      }
    },
    // 获取路由参数值
    getRouteValue () {
      this.form.env = this.$route.query.env || '';
      this.getProjectList('', this.form.env, true);
    },
    // 监听window窗口变化
    onWindowResize () {
      this.circleWidth = this.container.offsetWidth / 8;
    },
    // 每次加载10个文件
    load () {
      if (this.isLoad && this.historyFileList.length < this.history.length) {
        this.count += 10;
        this.historyFileList = this.history.slice(0, this.count) // 截取数组
      }
    },
    // 初始化用户列表--默认选中当前用户
    initUserList () {
      this.timer = setInterval(() => {
        this.userInfo[0].userId = this.$store.getters.userInfo.id || ''
        this.userInfo[0].fullName = this.$store.getters.userInfo.fullName || ''
        this.userId = this.userInfo[0].userId
      }, 100)
    },
    // 获取用户列表
    getUserList (realName) {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false
        const res = await userApi.getUserList({ realName })
        this.userInfo = res.userInfo
      }, 200);
    },
    // 获取项目列表
    async getProjectList (name = '', env, type) {
      showLoading();
      this.loading = true;
      const res = await fileManageApi.getProjects({ projectName: name, env });
      if (res.code === 200) {
        this.projectList = res.data;
        // 如果从路由中获取的值查询项目列表
        if (type) {
          this.$nextTick(() => {
            // 选中路由中默认的值
            this.form.path = this.$route.query.path || '';
            if (this.form.path) {
              this.form.day = '';
              // 判断特殊存储路径
              if (this.specialPath.includes(this.form.path)) {
                this.showSaveDay = parseInt(this.form.path.split('day')[1]);
              } else {
                this.showSaveDay = '';
              }
            }
            if (this.form.env || this.form.path) {
              this.isShowConfig = true;
            }
          })
        }
      } else {
        this.$message.error('服务异常！')
      }
      hideLoading();
      this.loading = false;
    },
    moment,
    // 获取当前文件对象
    getCurrentFile (uid) {
      return this.fileList.find(item => {
        return item.uid === uid;
      })
    },
    // 更改进度
    handleProgress (event, file, fileList) {
      const uid = file.uid || file;
      const currentFile = this.getCurrentFile(uid)
      currentFile.percent = Math.floor(event.percent - 1)
    },
    // 上传文件
    handleChange (file, fileList) {
      const status = file.status;
      let rspCode = '';
      if (file.response) {
        rspCode = file.response.rspCode;
      }
      let nowFile = this.getCurrentFile(file.uid);
      if (status === 'ready') {
        if (!nowFile) {
          this.fileList.push({ uid: file.uid, percent: 0, name: file.name, isImg: isImg(file.name), ext: getExt(file.name) });
        }
      }
      if (rspCode === 'success') {
        this.$message.success(`${file.name} 上传成功.`);
        nowFile.percent = 100
        Object.assign(nowFile, file.response)
        this.getHistoryFile()
      } else if (rspCode === 'error') {
        this.$message.error(`${file.name} 上传失败.`);
      }
    },
    // 日期下拉框改变触发
    dateHandleChange () {
      this.count = 10 // 默认显示10个记录
      this.getHistoryFile()
    },
    // 获取文件列表
    async getHistoryFile () {
      showLoading()
      if (!this.date && !this.userId) {
        hideLoading()
        return this.$message.error('必须保留一个筛选条件！')
      }
      const res = await xpsApi.getHistroyFile({ time: this.date, userId: this.userId });
      res.forEach(item => {
        item.isImg = isImg(item.url)
        item.ext = getExt(item.url)
      })
      this.history = res;
      this.historyFileList = this.history.slice(0, this.count)
      hideLoading()
    },
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    showDrawer (size) {
      this.size = size;
      this.visible = true
      this.showUnfoldIcon = false
    }
  },
}
</script>
<style lang="scss">
.function-upload-container {
  height: 100%;
  .title {
    .icon {
      float: right;
      font-size: 24px;
      color: #adb4bf;
      cursor: pointer;
      &.fullscreen-icon {
        margin-right: 10px;
      }
    }
  }
  .upload-card-container {
    display: flex;
    justify-content: space-between;
    max-height: 100%;
    .upload-form {
      position: relative;
      padding: 15px;
      margin: 0 10px 10px 10px;
      max-height: 365px;
      width: 200px;
      min-width: 200px;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .close-icon {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
        color: #adb4bf;
        cursor: pointer;
      }
    }
    .file-upload-container {
      position: relative;
      margin-bottom: 10px;
      padding: 15px;
      width: 100%;
      max-height: calc(100% - 40px);
      background: #fff;
      border-radius: 16px;
      overflow-y: auto;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      &::-webkit-scrollbar {
        display: none;
      }
      .upload-date-tips {
        display: inline-block;
        position: absolute;
        font-size: 12px;
        left: calc(50% - 58px);
        top: 10px;
        transform: translateX(-50%);
      }
      .file-config-icon {
        position: absolute;
        top: 0;
        left: 50%;
        width: 30px;
        height: 17px;
        transform: translateX(-50%);
        border-radius: 0 0 30px 30px;
        text-align: center;
        background-color: #c0c4cc;
        box-shadow: 0px 3px 3px #c0c4cc;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
      }
      .upload-tips {
        position: absolute;
        top: 10px;
        right: 20px;
        .tips-icon {
          color: #5862ab;
          font-size: 25px;
        }
      }
      .file-list-title {
        color: #cccbcc;
      }
      &:hover {
        box-shadow: 5px 5px 6px #cccccc;
      }
    }
  }
  .cover-box {
    height: 250px;
    text-align: center;
    > p {
      margin: 0;
    }
  }
  .histroy-list {
    padding: 0;
    padding-top: 5px;
  }

  .file-upload-card {
    position: relative;
    margin-bottom: 3px;
  }
  .ellipsis-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .xps-upload {
    width: 100%;
    .el-upload-dragger {
      height: 100% !important;
      background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload-gray-bg.webp");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      &:hover {
        background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload-bg.webp");
      }
    }
  }
  .file-icon {
    width: 100%;
    height: 220px;
    margin-bottom: 5px;
    background-repeat: no-repeat;
    background-size: 80% 200px;
    background-position: center;
  }
}
</style>